/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import { Row, Container } from 'react-bootstrap';
import { HeaderSVG } from '../../img/GlobalSVG';
import { HeaderLogo } from '../../configuration/ImagesPath';

export default function Header() {
  return (
    <div className="header">
      <Container>
        <Row>
          <img src={HeaderLogo} alt="logo" />
        </Row>
      </Container>
    </div>
  );
}
